import React,{Component} from 'react';
import '../selector/selector.scss';
import './empty-selector.scss';

export default class EmptySelector extends Component{

  constructor(props){
    super(props);
  }

  render(){
    return (
      <div className="empty">
        <p className="title-name"><span></span></p>
        <div className="main-selector">
          <ul className="selector">
            <li><a><div></div></a><p></p></li>
            <li><a><div></div></a><p></p></li>
            <li><a><div></div></a><p></p></li>
            <li><a><div></div></a><p></p></li>
          </ul>
        </div>
        {
          this.props.type ==2 ? (
              <div className="sub-selector">
                <ul className="selector">
                  <li><a><div></div></a><p></p></li>
                  <li><a><div></div></a><p></p></li>
                  <li><a><div></div></a><p></p></li>
                  <li><a><div></div></a><p></p></li>
                </ul>
              </div>
            ) : null
        }
      </div>
    );
  }
}
